$ = require 'jquery'

module.exports =
class Slider

  itemSelector     : '.slider .thumbnail'
  indicatorSelector: '.slider .dots li'
  isSelectedClass  : 'is-selected'

  constructor: (el) ->
    @$wrap = $ el

    @isAnime    = false
    @isAutoplay = false
    @timer      = null

  set: ->
    @$wrap.on 'click', @indicatorSelector, @onIndicatorClicked
    $item      = @$wrap.find @itemSelector
    $indicator = @$wrap.find @indicatorSelector

    itemLen = $item.length

    return if 1 >= itemLen.length

    @selection = 0

    $item.on
      'mouseover': => clearTimeout @timer
      'mouseout' : => @autoPlay()
    $item.eq @selection
      .css 'display', 'block'
    $item.not ":eq(#{@selection})"
      .css 'display', 'none'
    $indicator.eq @selection
      .addClass @isSelectedClass
    $indicator.not ":eq(#{@selection})"
      .removeClass @isSelectedClass

    clearTimeout @timer

  start: ->
    @isAutoplay = true
    @isAnime    = false
    @autoPlay()

  end: ->
    @isAutoplay = false
    @$wrap.off 'click', @indicatorSelector, @onIndicatorClicked
    clearTimeout @timer

  onIndicatorClicked: (e) =>
    $el = $ e.currentTarget
    index = @$wrap.find(@indicatorSelector).index $el
    @goTo index

  goTo: (target) ->
    return if @isAnime or (@selection is target)
    @isAnime = true
    clearTimeout @timer

    $item = @$wrap.find @itemSelector
    @slide $item.eq(@selection), false
    @slide $item.eq(target), true, =>
      @isAnime = false
      @autoPlay()
    @toggleClass target
    @selection = target

  next: ->
    itemLen = @$wrap.find(@itemSelector).length
    if (itemLen - 1) > @selection
      @goTo @selection + 1
    else
      @goTo 0

  autoPlay: ->
    return if @isAutoplay
    @timer = setTimeout =>
      return if @isAutoplay
      @next()
    , 5000

  slide: ($el, toggle, cb = null) ->
    if toggle
      x       = [ 0, '150%' ]
      easing  = 'easeOutBack'
      display = 'block'
    else
      x       = [ '-150%', 0 ]
      easing  = 'easeOutCubic'
      display = 'none'

    $el.velocity
      translateX: x
    ,
      duration: 500
      easing  : easing
      display : display
      complete: =>
        cb() if cb

  toggleClass: (target) ->
    $indicator = @$wrap.find @indicatorSelector
    $indicator.eq(@selection).removeClass @isSelectedClass
    $indicator.eq(target).addClass @isSelectedClass



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/slider.coffee